// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../style-loader/index.js!../../css-loader/index.js!./vue-material.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("5043ab8e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-material/dist/vue-material.css
// module id = 188
// module chunks = 0